module.exports = __webpack_public_path__ + "static/Danzza-Light-379a29621ce0ad202827487c044dd003.woff2";